import {
  TournamentPage,
  TournamentResult,
  TTierDescriptions,
  TTierRank,
} from "../../types/tournamentTypes";
import { DataTable } from "../DataTable/DataTable";
import { getDateRangeDisplay } from "../../util/dateUtils";
import { TournamentLink } from "./TournamentLink";
import { useMemo } from "react";

export function ResultsTable(props: {
  page: Partial<TournamentPage>;
  results: TournamentResult[];
}) {
  const hasPrize = useMemo(() => {
    return props.results.some((result) => !!result.prize);
  }, [props.results]);
  return (
    <DataTable
      data={props.results}
      fallbackContent={<p>No Results Found</p>}
      columns={[
        {
          title: "Date",
          property: "date",
          render: (obj) => getDateRangeDisplay(obj.endDate),
          sortFunc: (obj) => obj.endDate,
        },
        {
          title: "Tournament",
          property: "tournament",
          render: (obj) => (
            <TournamentLink
              pageId={obj.tournamentId}
              secondaryId={obj.secondaryId}
              navigateState={{
                tournamentSelectedTeam: obj.teamName || props.page.pageId,
              }}
            />
          ),
          sortFunc: (obj) => `${obj.tournamentId}-${obj.secondaryId}`,
          maxWidth: 250,
        },
        {
          title: "Tier",
          property: "tier",
          render: (obj) => TTierDescriptions[obj.tier],
          sortFunc: (obj) => TTierRank[obj.tier],
          defaultSortDirection: "desc",
        },
        {
          title: "Place",
          property: "place",
          render: (obj) => {
            if (obj.totalTeams === 0) return "-";
            return (
              <span>
                <b>{obj.place || "?"}</b> / {obj.totalTeams}
              </span>
            );
          },
          sortFunc: (obj) => obj.place || 1000, // Unknown to the bottom
        },
        {
          title: "Team",
          property: "team",
          visible: props.page.pageType === "QUIZZER",
          render: (obj) => (
            <TournamentLink
              pageId={obj.teamId || obj.teamName}
              text={obj.teamName}
            />
          ),
          sortFunc: (obj) => obj.teamName || "",
        },
        {
          title: "Individual",
          property: "indiv",
          visible: props.page.pageType === "QUIZZER",
          render: (obj) =>
            obj.totalQuizzers ? (
              <span>
                <b>{obj.indivPlace || "?"}</b> / {obj.totalQuizzers}
              </span>
            ) : undefined,
          sortFunc: (obj) => obj.indivPlace || 10000, // Unknown to the bottom
        },
        {
          title: "Prize",
          property: "prize",
          visible: hasPrize,
          render: (obj) => (obj.prize ? `$${obj.prize}` : undefined),
          sortFunc: (obj) => obj.prize || 0,
          defaultSortDirection: "desc",
        },
      ]}
      getKey={(obj) => `${obj.tournamentId}-${obj.secondaryId}`}
    />
  );
}
